import { DOCUMENT } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit, inject } from "@angular/core";
import { AnimationUtils, LocalComponentStore } from "@dtm-frontend/shared/utils";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Store } from "@ngxs/store";
import { first, skip } from "rxjs";
import { UIActions } from "../../state/ui.actions";
import { UIState } from "../../state/ui.state";

const FADE_ANIMATION_DURATION = 200;

@UntilDestroy()
@Component({
    selector: "dtm-ui-user-interaction-overlay",
    templateUrl: "./user-interaction-overlay.component.html",
    styleUrls: ["./user-interaction-overlay.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LocalComponentStore],
    animations: [AnimationUtils.fadeAnimation(FADE_ANIMATION_DURATION)],
})
export class UserInteractionOverlayComponent implements OnInit {
    private readonly store = inject(Store);
    private readonly document = inject(DOCUMENT);

    protected shouldShowUserInteractionOverlay$ = this.store.select(UIState.shouldShowUserInteractionOverlay);

    public ngOnInit(): void {
        this.document.addEventListener("pointerup", this.boundInteract);

        this.shouldShowUserInteractionOverlay$
            .pipe(
                skip(1),
                first((shouldShow) => !shouldShow),
                untilDestroyed(this)
            )
            .subscribe(() => {
                this.document.removeEventListener("pointerup", this.boundInteract);
            });
    }

    private interact() {
        queueMicrotask(() => {
            this.store.dispatch(UIActions.EnsureUserInteraction);
        });
    }
    private boundInteract = this.interact.bind(this);
}
